import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1059"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.284 9.164a.491.491 0 0 0-.325.122l-4.966 4.349-4.967-4.349a.491.491 0 0 0-.325-.122H1.48a.102.102 0 0 0-.067.178l6.376 5.583a.309.309 0 0 0 .407 0l6.376-5.583a.102.102 0 0 0-.067-.178h-1.221z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M7.789 12.42a.309.309 0 0 0 .407 0l6.376-5.583a.102.102 0 0 0-.067-.178h-1.221a.491.491 0 0 0-.325.122L7.992 11.13 3.026 6.781a.491.491 0 0 0-.325-.122H1.48a.102.102 0 0 0-.067.178l6.376 5.583z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M7.836 9.883a.237.237 0 0 0 .312 0l6.253-5.475a.304.304 0 0 0-.2-.532h-2.272v-2.42a.475.475 0 0 0-.475-.475H4.403a.475.475 0 0 0-.475.475v2.419H1.784a.303.303 0 0 0-.2.532l6.252 5.476z" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }